export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "Language": "pl-PL",
    "Messages": {
        "API Url": "",
        "Bazowy adres API Ipresso.": "",
        "CUSTOMER_KEY": "",
        "Dane dostępowe integracji marketing automation.": "",
        "Dane są nie prawidłowe.": "",
        "Dane są prawidłowe.": "",
        "Hasło": "",
        "Hasło konta integracyjnego.": "",
        "Ipresso": "",
        "Klucz klienta nadany przez Ipresso.": "",
        "Login": "",
        "Login konta integracyjnego.": "",
        "Paleta kolorów": "",
        "Pokaż hasło": "",
        "Pokaż klucz klienta": "",
        "Połączenie Ipresso": "",
        "Przetestuj poprawność danych": "",
        "Synchronizacja kontaktów": "",
        "Synchronizacja ustawień": "",
        "Synchronizacja zgód kontaktów": "",
        "System": "",
        "Ukryj hasło": "",
        "Ukryj klucz klienta": "",
        "Ustawienia": "",
        "Ustawienia zostały zapisane.": "",
        "Zadanie synchronizacji kontaktów Ipresso zostało rozpoczęte.": "",
        "Zadanie synchronizacji ustawień Ipresso zostało rozpoczęte.": "",
        "Zadanie synchronizacji zgód kontaktów Ipresso zostało rozpoczęte.": "",
        "Zapisz": ""
    }
};
